/**
 * Format a phone number to a readable format
 * @param phoneNumber - The phone number to format
 * @returns The formatted phone number with spaces
 *
 * If the phone number has prefix, a spaces is added between the prefix and the number
 * If the phone number has no prefix, a space will be added between the first and second group of numbers
 * If the phone number is not valid, it will be returned as is
 */
export const formatPhoneNumber = (phoneNumber?: string): string => {
  if (!phoneNumber) {
    return '';
  }
  if (!/^\+?\d+$/.test(phoneNumber)) {
    console.warn('Number cannot be formatted', phoneNumber);
    return phoneNumber;
  }
  if (phoneNumber.startsWith('+')) {
    return phoneNumber.replace(/(\d{2})(\d{3})(\d{4})/, '$1 $2 $3');
  }
  return phoneNumber.replace(/(\d{3})(\d{4})/, '$1 $2');
};
